import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SubscriptionDivider = ({ className }) => (
  <div className={classNames('subscription-divider', className)} />
);

SubscriptionDivider.defaultProps = {
  className: '',
};

SubscriptionDivider.propTypes = {
  className: PropTypes.string,
};

export default memo(SubscriptionDivider);
